import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const SEO = ({ titleRu, titleEn, descriptionRu, descriptionEn, canonical, image, noindex = false }) => {
    const { i18n } = useTranslation();
    const isRussian = i18n.language === 'ru';
    
    const title = isRussian ? titleRu : titleEn;
    const description = isRussian ? descriptionRu : descriptionEn;
    const lang = isRussian ? 'ru' : 'en';
    
    // Default image if not provided
    const ogImage = image || 'https://apps.fleep.bot/og-image.png';
    
    // Build canonical URL
    const canonicalUrl = canonical || window.location.href.split('?')[0].split('#')[0];
    
    // Robots meta content based on noindex prop
    const robotsContent = noindex ? 'noindex, nofollow' : 'index, follow';

    return (
        <Helmet>
            {/* HTML lang attribute */}
            <html lang={lang} />
            
            {/* Primary Meta Tags */}
            {title && <title>{title}</title>}
            {title && <meta name="title" content={title} />}
            {description && <meta name="description" content={description} />}
            
            {/* Canonical URL */}
            <link rel="canonical" href={canonicalUrl} />
            
            {/* Open Graph / Facebook */}
            {title && (
                <>
                    <meta property="og:type" content="website" />
                    <meta property="og:url" content={canonicalUrl} />
                    <meta property="og:title" content={title} />
                    {description && <meta property="og:description" content={description} />}
                    <meta property="og:image" content={ogImage} />
                    <meta property="og:locale" content={isRussian ? 'ru_RU' : 'en_US'} />
                </>
            )}
            
            {/* Twitter */}
            {title && (
                <>
                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:url" content={canonicalUrl} />
                    <meta name="twitter:title" content={title} />
                    {description && <meta name="twitter:description" content={description} />}
                    <meta name="twitter:image" content={ogImage} />
                </>
            )}
            
            {/* Robots */}
            <meta name="robots" content={robotsContent} />
            <meta name="googlebot" content={robotsContent} />
        </Helmet>
    );
};

export default SEO;
